import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import InstagramMedia from "../../atomic/molecules/InstagramMedia"
import { H3 } from "../../atomic/atoms/type/H3"
import { TYPE, COLORS } from "../../../theme/styles/globals"

export default class ContentfulBlockInstagramFeed extends React.Component {

  state = {
    posts: null,
  }

  componentDidMount() {
    fetch(`/.netlify/functions/instagram`)
      .then(res => res.json())
      .then(data => this.setState({ posts: data }))
  }

  render() {
    return (
      <Container>
        <Text>
          <Accent>@slikdigital</Accent>
          <Title>
            Slide into
            <br />
            our DMs
          </Title>
        </Text>
        <InstaWrap>
          <VerticalAccent>From the feed</VerticalAccent>
          {this.state.posts && (
            <InstagramMedia
              type={this.state.posts[0].type}
              caption={this.state.posts[0].caption}
              thumbnail={this.state.posts[0].thumbnail}
              video={this.state.posts[0].video}
              url={this.state.posts[0].url}
            />
          )}
        </InstaWrap>
      </Container>
    )
  }
}

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  margin-bottom: -30px;

  ${up("md")} {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: auto;
  }
`

const InstaWrap = styled.div`
  position: relative;
  /* padding-left:20px;
  padding-right:20px; */

  ${up("md")} {
    width: 60vh;
    height: 60vh;
    padding-left: 0px;
    padding-right: 0px;
  }
`

const Text = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;

  ${up("md")} {
    flex-shrink: 1;
    margin-right: 60px;
    padding-left: 0px;
    padding-right: 0px;
  }
`

const Accent = styled.p`
  font-family: ${TYPE.MONO_FONT};
  text-transform: uppercase;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: 2px;
  display: block;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};

  ${up("md")} {
    &::before {
      content: " ";
      width: 80px;
      height: 1px;
      background-color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
      display: inline-block;
      margin-right: 20px;
      transform: translate(0px, -3px);
    }
  }
`

const Title = styled(H3)`
  font-size: 42px;
  line-height: 42px;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
  margin-top: 20px;

  ${up("sm")} {
    font-size: 48px;
    line-height: 48px;
  }

  ${up("md")} {
    font-size: 72px;
    line-height: 72px;
    margin-top: 30px;
  }
`

const VerticalAccent = styled.p`
  display: none;
  position: absolute;
  left: -70px;
  top: 50px;
  font-family: ${TYPE.MONO_FONT};
  text-transform: uppercase;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: 2px;
  display: block;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
  transform: rotate(270deg);

  ${up("md")} {
    display: block;
  }
`
